<script setup lang="ts">
import ApplicationBase from '@/components/Applications/ApplicationBase.vue'

// Your existing step components (keep names as-is)
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import PEP from '../Shared/PEP.vue'
import Summary from './Steps/Summary.vue'
import Undirritun from '../Shared/Undirritun.vue'
import LokaSkref from '../Shared/LokaSkref.vue'
import BeginStep from './Steps/Uppsogn_sereign_begin.vue'

// App constants
const APP_ID = 7
const UPDATE_KEY = 'uppsogn-samning-sereign'

// Steps config. ApplicationBase renders nav/buttons and calls validate() on steps if exposed.
const steps = [
    { comp: BeginStep,  titleKey: '' },
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,       titleKey: 'umsokn_uppsogn_samning_step2_header3' },
  { comp: Step3,       titleKey: 'Flutningur' },
  { comp: Step4,       titleKey: 'umsokn_uppsogn_samning_step4_fjarfestingarleid' },

  // PEP in the flow (disclaimer ON), like legacy step 5
  { comp: PEP,         titleKey: 'umsokn_PEP_header', props: { showDisclamer: true } },

  // Summary (read-only), like legacy step 6
  { comp: Summary,     titleKey: 'umsokn_samantekt_header' },

  // Undirritun (signing), like legacy step 7
  // If you need to trigger document creation on entry, handle inside the Undirritun component’s mounted/validate.
  { comp: Undirritun,  titleKey: 'undirritun_umsokn_header1' },

  // Final step, like legacy step 8
//   { comp: LokaSkref,   titleKey: 'umsokn_lokaskref_header' },
]
</script>

<template>
  <ApplicationBase :app-id="APP_ID" :update-key="UPDATE_KEY" :steps="steps" />
</template>
